// import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
// import { Modal } from "react-bootstrap";
import { checkTextTranslation, checkTranslation, translate } from "../../utils/useful";
// import FixedView from "../FixedView";
// import Modal from "../Modal";
// import inputComponents from "./inputComponents";
// import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../utils/functions";
import SidebarView from "../SidebarView";
// import FilterItems from "./FilterItems";
// import SaveFilter from './SaveFilter'
// import LoaderButton from "../LoaderButton";
import ButtonAnimated from "../buttons/ButtonAnimated";
import FilterEditorInput from "./FilterEditorInput";
import FormViewer from "../FormViewer";
import SwitchStyle1 from "../useful/SwitchButton";
import PrintFinalModal from "../modals/PrintFinalModal";


class printModal extends Component {
    state = {

        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title ...', required: true } },
            { key: 'qrCodeLink', type: 'TextInput', col: '12', information: { label: '{{lang}}Qr Code Link', placeholder: '{{lang}}Select ...', required: false } },

            {
                type: 'SubformInput',
                key: 'items',
                information: {
                    inputClass: 'mt-2 p-0',
                    // label: '{{lang}}applets.accounting.items',
                    headers: [
                        { key: 'product', type: 'ProductSelectInput', col: '8', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: {frame: '{{frameId}}',hub: '{{appletHub}}', applet: '{{appletId}}', appletHub: '{{appletHub}}' }, fields: { title: 'name', description: 'description', name: 'name', media: 'media', image: 'images', value: '_id', _id: '_id', price: 'price', type: 'type', priceType: 'priceType', subscriptionPrice: 'subscriptionPrice', inventory: 'inventory', variants: 'variants', includesVariants: "includesVariants", additionals: 'additionals', paymentType: 'paymentType', fulfillments: 'fulfillments', unit: 'unit', SKU: 'SKU', barcode: 'barcode' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: true, returnFullValue: true }, showMain: true },
                        { key: 'count', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: true } },
                    ],

                    placeholder: '{{lang}}placeholders.insertInformation',
                    required: false
                },
                required: false,

                showMain: false
            },
            { key: 'template', type: 'TemplateSelectInput', col: '12', information: { type: "local", items: [{ title: '{{lang}}Text Up,barcode', value: 'template12' }, { title: '{{lang}}Text Up,barcode Big', value: 'template13' }, { title: '{{lang}}QR Code Left, Text Right,barcode', value: 'template11' }, { title: '{{lang}}QR Code Above, Text Below', value: 'template1' }, { title: '{{lang}}QR Code Left, Text Right', value: 'template2' }, { title: '{{lang}}Barcode Above, Text Below', value: 'template3' }, { title: '{{lang}}Barcode Left, Text Right', value: 'template4' }, { title: '{{lang}}QR Code and Barcode Side by Side', value: 'template5' }, { title: '{{lang}}QR Code Above, Barcode Below', value: 'template6' }, { title: '{{lang}}QR Code Above, Barcode Below', value: 'template7' }, { title: '{{lang}}QR Code Above, Barcode Below', value: 'template8' }, { title: '{{lang}}QR Code Above, Barcode Below', value: 'template9' }, { title: '{{lang}}QR Code Above, Barcode Below', value: 'template10' }], label: '{{lang}}Template', placeholder: 'Choose...', required: true } },
            { key: 'labelSize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '{{lang}}Small (3.5 cm x 2.5 cm)', value: 'size1' }, { title: '{{lang}}Small (5.1 cm x 3.4 cm)', value: 'size8' }, { title: '{{lang}}Small (4 cm x 2 cm)', value: 'size2' }, { title: '{{lang}}Medium (8 cm x 4 cm)', value: 'size3' }, { title: '{{lang}}Large (11 cm x 6 cm)', value: 'size4' }, { title: '{{lang}}Square Small (4 cm x 4 cm)', value: 'size5' }, { title: '{{lang}}Square Medium (6 cm x 6 cm)', value: 'size6' }, { title: '{{lang}}Square Large (11 cm x 11 cm)', value: 'size7' }], label: '{{lang}}Label Size', placeholder: 'Choose...', required: true } },
            { key: 'paperSize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '{{lang}}Small (3.5 cm x 2.5 cm)', value: 'size1' }, { title: '{{lang}}Small (4 cm x 2 cm)', value: 'size2' }, { title: '{{lang}}Medium (8 cm x 4 cm)', value: 'size3' }, { title: '{{lang}}Large (11 cm x 6 cm)', value: 'size4' }, { title: '{{lang}}Large (11 cm x 2.5 cm)', value: 'size8' }, { title: '{{lang}}Large (11 cm x 3.4 cm)', value: 'size9' }, { title: '{{lang}}Square Small (4 cm x 4 cm)', value: 'size5' }, { title: '{{lang}}Square Medium (6 cm x 6 cm)', value: 'size6' }, { title: '{{lang}}Square Large (11 cm x 11 cm)', value: 'size7' }], label: '{{lang}}Paper Size', placeholder: 'Choose...', required: true } }

        ],

        options: [
            { title: "{{lang}}Add view name as title" },
            { title: "{{lang}}Include row Numbers" },
            { title: "{{lang}}Wrap long text into multiple lines" },
        ],

        tempData: {},
        transformed: {},
        filters: [],
        templates: [
            { "templateId": "template1", "key": "qrTopTextBottom", "name": "QR Code Above, Text Below" },
            { "templateId": "template2", "key": "qrLeftTextRight", "name": "QR Code Left, Text Right" },
            { "templateId": "template3", "key": "barcodeTopTextBottom", "name": "Barcode Above, Text Below" },
            { "templateId": "template4", "key": "barcodeLeftTextRight", "name": "Barcode Left, Text Right" },
            { "templateId": "template5", "key": "qrBarcodeSideBySide", "name": "QR Code and Barcode Side by Side" },
            { "templateId": "template6", "key": "qrBarcodeStacked", "name": "QR Code Above, Barcode Below" }
        ]

    }

    componentDidMount() {
        // let current = { level: 0, groupId: 'root', parents: [] }
        if (this.props.data) {
            this.setState({ data: this.props.data })
        }
        if (this.props.filters) {
            this.setState({ filters: this.props.filters })
        }
        // else {
        //     this.setState({ current }, () => {
        //         this.doAdd('con', current)
        //     })
        // }
        // this.setState({ items: this.props.headers }, () => {
        // });
        this.init()

    }


    componentDidUpdate(prevProps) {
        if (prevProps.headers != this.props.headers) {
            this.init()
        }
        if (prevProps.data != this.props.data) {
            this.setState({ data: this.props.data })
        }
        if (prevProps.filters != this.props.filters) {
            this.setState({ filters: this.props.filters })
        }
    }


    init() {
        this.setState({ items: this.props.headers })
        // let element
        // for (let i = 0; i < this.props.headers?.length; i++) {
        //     // element = this.props.headers[i];

        //     // this.setState({ slectedCell: element }, () => {
        //     // })
        // }
    }




    generateVisual(data) {
        if (data) {
            return this.generateGroupVisual(data.root)
        } else {
            return " "
        }
    }

    generateGroupVisual(group) {
        let text = ""
        if (group && group.conditions && typeof group.conditions == 'object') {
            // text = '('
            Object.values(group.conditions).forEach((oneInGroup, index) => {
                let onInGroupSource = ''

                this.props.headers.forEach(el => {
                    if (el.key == oneInGroup.source) {
                        onInGroupSource = el?.information?.label
                        return
                    }
                });
                if (index != 0) {
                    if (group.action == 'and') {
                        text = text + " & "
                    }
                    if (group.action == 'or') {
                        text = text + " | "
                    }
                }

                if (oneInGroup.action) {
                    text = translate('Multiple filters')
                    // text = text + this.generateGroupVisual(oneInGroup)
                } else {

                    text = text + onInGroupSource + " " + oneInGroup.operator
                    if (oneInGroup.target && oneInGroup.target != null) {
                        text = text + " " + oneInGroup.target
                    }
                    // text = text + oneInGroup.source + " " + oneInGroup.operator + " " + oneInGroup.target
                }
            });
            // text = text + ")"
        }
        // this.props.setData('filters', filters,'CollectionView')
        return text
    }


    open = () => {
        this.filterEditor.open()
    }
    applyPrint = () => {
        let form = this.form.getForm()
        if (form) {
            const transformed = {

                title: form.title,
                template: form.template,
                labelSize: form.labelSize,
                paperSize: form.paperSize,
                qrCodeLink: form.qrCodeLink,
                labels: form.items.flatMap(item => Array(item.count).fill(item.product))
            };
            this.setState({ transformed }, () => {
                setTimeout(() => {

                    this.PrintFinalModal.modal.open()
                }, 20);
            })

        }
    }


    changeValue = (key, value, extra) => {

        this.setState({ [key]: value })
        // this.setState({ data: value })
    }

    removeRow = (group_id, id, parents) => {
        let groupId = 'root'
        let current = { groupId, id, parents }
        let data = this.state.data
        this.actionOnChild(data, current, null, 'remove', 0)
        // if(data?.root&&data?.root?.conditions&&Object.values(data?.root?.conditions).length==0){
        //     data = {}
        // }
        this.setState({ data: data }, () => {
            this.props.changeValue('data', data)
            console.log('this.state.data?.root?.conditions', Object.entries(this.state.data?.root?.conditions))
            if (Object.entries(this.state.data?.root?.conditions).length == 0) {
                this.props.setData('hasFilter', false, "CollectionView", () => {
                    if (this.props.setHeader) {
                        this.props.setHeader("dummy", 1)
                    }
                })
            }
        })
    }

    actionOnChild(data, current, value, action, index, cb) {
        if (index == current.parents.length) {

            if (action == 'add') {

                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                if (!data[current.groupId].conditions) {
                    data[current.groupId].conditions = {}
                }
                data[current.groupId].conditions[current.id] = value

            }

            if (action == 'remove') {
                if (current.id == null) {
                    delete data[current.groupId]
                    return data
                } else {
                    delete data[current.groupId].conditions[current.id]
                    return data
                }
            }

            if (action == 'changeOperator') {
                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                data[current.groupId].action = value
            }

            if (action == 'update') {
                data[current.groupId].conditions[current.id][current.key] = value
            }

            if (action == 'get') {
                return data[current.groupId].conditions[current.id][current.key]
            }

        } else if (index < current.parents.length) {
            let newData = data[current.parents[index]]
            if (newData) {
                return this.actionOnChild(newData.conditions, current, value, action, index + 1)
            }
        }
    }


    render() {

        return (
            <>


                <PrintFinalModal ref={el => this.PrintFinalModal = el} variables={this.props.variables} width={this.props.width} colors={this.props.colors} data={this.state.transformed} isLoading={this.state.isLoadingData} />


                <SidebarView width={this.props.width} ref={el => this.filterEditor = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '40%', lg: "35%", xl: "30%" }} >
                    <div className="w-100" style={{ maxHeight: "100%", overflow: "auto" }}>


                        <div className="w-100 br-10" style={{ backgroundColor: "white", overflow: 'hidden' }} >
                            <div className='p-3 position-sticky top-0' style={{ background: 'linear-gradient(90deg, #5856D6, #7D7AFF)', zIndex: 2, height: '50px' }}>
                                <p className="font-size-18 weight-500 white">{translate('Print Setting')}</p>
                            </div>
                            <div className="mt-3 px-2" style={{}}>
                                <FormViewer ref={el => this.form = el} variables={this.props.variables} headers={this.state.headers} theme={"modern"} inputClass={"modern-input4"} />
                            </div>
                            {/* <div className="px-4">
                                {this.state.options.map((prop, index) => {
                                    return (
                                        <div className="flexcb w-100 py-2" key={index}>
                                            <p className="font-size-14 weight-300">{checkTranslation(prop.title)}</p>
                                            <div className="flexcc">
                                                <SwitchStyle1 id={index} color={'#4E4CCC'} />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div> */}
                            <div className="mx-4 mt-4 br-15" style={{ backgroundColor: "#f6f6f6" }}>
                                <p className="p-3 font-size-12 weight-300">{translate('Create Completely custom print layouts with the')}<span className="text-link"> {translate('page builder')} </span>{translate('feture')}.</p>
                            </div>
                            <div className="p-4 w-100 d-flex" style={{ justifyContent: "flex-end" }}>
                                <button className="gray-btn px-3 py-2 br-5">
                                    <p>{translate('Cancel')}</p>
                                </button>
                                <button onClick={() => { this.applyPrint() }} className="px-4 py-2 br-5 mld-4 purple-btn">
                                    <p className="white font-size-14">{translate('Print')}</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </SidebarView>

                <SidebarView ref={el => this.saveSidebar = el} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }}>
                    <div className="flexcc" style={{ height: "100%", backgroundColor: "rgb(170, 185, 207", width: "100%" }}>
                        <div className="flexcc flex-column" style={{ backgroundColor: "#fff", gap: "1.5em", height: "200px", width: "300px", boxShadow: "0px 0px 30px #10101030", borderRadius: "15px" }}>
                            {/* style={{backgroundColor:"#fff",borderRadius:"15px",boxShadow:"0px 0px 30px #10101090",height:"100vh"}} */}
                            <div className="" style={{ fontWeight: "bold" }}>
                                <p>{translate('Save your filter')}</p>
                            </div>
                            <div className="flexcb flex-column" style={{ gap: "1em" }}>
                                <div className="">
                                    <input className="p-2" type="text" placeholder={translate("Insert your filter name")} style={{ width: "250px", border: "none", backgroundColor: "#e8e8e8", borderRadius: "5px" }} />
                                </div>
                                <div className="py-2 px-3 flexcc" style={{ backgroundColor: "rgb(150, 175, 207", borderRadius: '5px', boxShadow: "0px 0px 5px #0002" }}>
                                    <button style={{ color: "#fff" }}>{translate('Add Filter')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarView>
            </>
        )
    }
}

export default printModal;